// extracted by mini-css-extract-plugin
export var container = "ProductLink-module--container--p6-cU";
export var content = "ProductLink-module--content--z87f1";
export var image = "ProductLink-module--image--xymfL";